import { Yii } from "libraries/interfaces/Yii";
// Angular
import { Injectable } from '@angular/core';
// Afidium
import { IVariableEntry } from '../../../model/IVariableEntry';

@Injectable()
export class SmsTextGenerationService {
    private labels = {
        sectorsDetails: Yii.t('wui-shared-js', "Détails des secteurs"),
        travellersDetails: Yii.t('wui-shared-js', "Détails des voyageurs"),
        luggagesDetails: Yii.t('wui-shared-js', "Détails des bagages"),
        customersDetails: Yii.t('wui-shared-js', "Détails des clients"),
    };

    private code: IVariableEntry = {
        code: "{{code}}",
        explanation: Yii.t('wui-shared-js', "Code du dossier")
    };

    private agent: IVariableEntry = {
        code: "agent",
        explanation: Yii.t('wui-shared-js', "Informations sur l'agent"),
        children: [
            { code: "{{firstname}}", explanation: Yii.t('wui-shared-js', "Prénom") },
            { code: "{{lastname}}", explanation: Yii.t('wui-shared-js', "Nom") },
            { code: "{{name}}", explanation: Yii.t('wui-shared-js', "Nom + prénom de l'agent") },
            { code: "{{#emails}}{{.}}{{/emails}}", explanation: Yii.t('wui-shared-js', "Tableau d'adresses email") },
        ]
    };

    private customer: IVariableEntry = {
        code: "customer",
        explanation: Yii.t('wui-shared-js', "Informations sur le client"),
        children: [
            { code: "{{title}}", explanation: Yii.t('wui-shared-js', "M., Mme., Mlle") },
            { code: "{{firstname}}", explanation: Yii.t('wui-shared-js', "Prénom") },
            { code: "{{lastname}}", explanation: Yii.t('wui-shared-js', "Nom") },
            { code: "{{name}}", explanation: Yii.t('wui-shared-js', "Nom + prénom du client") },
            { code: "{{#emails}}{{.}}{{/emails}}", explanation: Yii.t('wui-shared-js', "Tableau de numéros de téléphone") },
            { code: "{{emails}}", explanation: Yii.t('wui-shared-js', "Tableau d'adresses email") },
            { code: "{{#phonenumbers}}{{/phonenumbers}}", explanation: Yii.t('wui-shared-js', "Tableau de numéros de téléphone") },
            {
                code: "phonenumbers",
                explanation: Yii.t('wui-shared-js', "Informations communes aux numéros de téléphone"),
                children: [
                    { code: "{{description}}", explanation: Yii.t('wui-shared-js', "Description du numéro de téléphone") },
                    { code: "{{number}}", explanation: Yii.t('wui-shared-js', "Numéro de téléphone") },
                ]
            },
            { code: "{{address}}", explanation: Yii.t('wui-shared-js', "Adresse (y compris ville et pays") },
        ]
    };

    private travellers: IVariableEntry = {
        code: "travellers",
        explanation: Yii.t('wui-shared-js', "Tableau de voyageurs"),
        children: [
            { code: "{{title}}", explanation: Yii.t('wui-shared-js', "M., Mme., Mlle") },
            { code: "{{firstname}}", explanation: Yii.t('wui-shared-js', "Prénom") },
            { code: "{{lastname}}", explanation: Yii.t('wui-shared-js', "Nom") },
            { code: "{{givenname}}", explanation: Yii.t('wui-shared-js', "Surnom") },
            { code: "{{name}}", explanation: Yii.t('wui-shared-js', "Prénom + (givenname) + nom de famille du voyageur") },
            { code: "{{type}}", explanation: Yii.t('wui-shared-js', "Adulte, enfant, bébé") }
        ]
    };

    private alltravellers: IVariableEntry = {
        code: "{{alltravellers}}",
        explanation: Yii.t('wui-shared-js', "liste de noms de voyageurs, séparés par une virgule")
    };

    private price: IVariableEntry = {
        code: "price",
        explanation: Yii.t('wui-shared-js', "Prix"),
        children: [
            { code: "{{cost}}", explanation: Yii.t('wui-shared-js', "prix formaté (par exemple '1 203,52€' ou '$1,235.02' selon la langue (et la monnaie))") },
            { code: "{{retail}}", explanation: Yii.t('wui-shared-js', "Prénom") },
        ]
    };

    private carrier: IVariableEntry = {
        code: "{{carrier}}",
        explanation: Yii.t('wui-shared-js', "Compagnie")
    };

    private carriercode: IVariableEntry = {
        code: "{{carriercode}}",
        explanation: Yii.t('wui-shared-js', "Code compagnie")
    };

    private departure: IVariableEntry = {
        code: "departure",
        explanation: Yii.t('wui-shared-js', "Informations sur le départ"),
        children: [
            { code: "{{departure.airport}}", explanation: Yii.t('wui-shared-js', "Nom de l'aéroport de départ") },
            { code: "{{departure.airportcode}}", explanation: Yii.t('wui-shared-js', "Code de l'aéroport de départ") },
            { code: "{{departure.carrier}}", explanation: Yii.t('wui-shared-js', "Nom de la compagnie") },
            { code: "{{departure.carriercode}}", explanation: Yii.t('wui-shared-js', "Code de la compagnie") },
            { code: "{{departure.city}}", explanation: Yii.t('wui-shared-js', "Ville de départ") },
            { code: "{{departure.citycode}}", explanation: Yii.t('wui-shared-js', "Code de la ville de départ") },
            { code: "{{departure.country}}", explanation: Yii.t('wui-shared-js', "Nom du pays de départ") },
            { code: "{{departure.countrycode}}", explanation: Yii.t('wui-shared-js', "Code du pays de départ") },
            { code: "{{departure.longdate}}", explanation: Yii.t('wui-shared-js', "Date de départ (format long)") },
            { code: "{{departure.shortdate}}", explanation: Yii.t('wui-shared-js', "Date de départ (format court)") },
            { code: "{{departure.longtime}}", explanation: Yii.t('wui-shared-js', "Heure de départ (format long)") },
            { code: "{{departure.shorttime}}", explanation: Yii.t('wui-shared-js', "Heure de départ (format court)") },
            { code: "{{departure.flightnumber}}", explanation: Yii.t('wui-shared-js', "Numéro de vol") },
            { code: "{{departure.terminal}}", explanation: Yii.t('wui-shared-js', "Terminal de départ") },
        ]
    };

    private arrival: IVariableEntry = {
        code: "arrival",
        explanation: Yii.t('wui-shared-js', "Informations sur l'arrivée"),
        children: [
            { code: "{{arrival.airport}}", explanation: Yii.t('wui-shared-js', "Nom de l'aéroport d'arrivée") },
            { code: "{{arrival.airportcode}}", explanation: Yii.t('wui-shared-js', "Code de l'aéroport d'arrivée") },
            { code: "{{arrival.carrier}}", explanation: Yii.t('wui-shared-js', "Nom de la compagnie") },
            { code: "{{arrival.carriercode}}", explanation: Yii.t('wui-shared-js', "Code de la compagnie") },
            { code: "{{arrival.city}}", explanation: Yii.t('wui-shared-js', "Ville d'arrivée") },
            { code: "{{arrival.citycode}}", explanation: Yii.t('wui-shared-js', "Code de la ville d'arrivée") },
            { code: "{{arrival.country}}", explanation: Yii.t('wui-shared-js', "Nom du pays d'arrivée") },
            { code: "{{arrival.countrycode}}", explanation: Yii.t('wui-shared-js', "Code du pays d'arrivée") },
            { code: "{{arrival.longdate}}", explanation: Yii.t('wui-shared-js', "Date d'arrivée (format long)") },
            { code: "{{arrival.shortdate}}", explanation: Yii.t('wui-shared-js', "Date d'arrivée (format court)") },
            { code: "{{arrival.longtime}}", explanation: Yii.t('wui-shared-js', "Heure d'arrivée (format long)") },
            { code: "{{arrival.shorttime}}", explanation: Yii.t('wui-shared-js', "Heure d'arrivée (format court)") },
            { code: "{{arrival.flightnumber}}", explanation: Yii.t('wui-shared-js', "Numéro de vol") },
            { code: "{{arrival.terminal}}", explanation: Yii.t('wui-shared-js', "Terminal d'arrivée") },
        ]
    };

    private sectors: IVariableEntry = {
        code: "sectors",
        explanation: Yii.t('wui-shared-js', "Tableau de secteurs du dossier"),
        children: [
            { code: "{{flightnumber}}", explanation: Yii.t('wui-shared-js', "Numéro du vol") },
            { code: "{{status}}", explanation: Yii.t('wui-shared-js', "Statut") },
            { code: "{{carrier}}", explanation: Yii.t('wui-shared-js', "Compagnie") },
            { code: "{{carriercode}}", explanation: Yii.t('wui-shared-js', "Code compagnie") },
            this.departure,
            this.arrival,
            { code: "{{duration}}", explanation: Yii.t('wui-shared-js', "Durée") },
            { code: `{{#travellers}}${this.labels.travellersDetails}{{/travellers}}`, explanation: Yii.t('wui-shared-js', "Liste des voyageurs")},
            {
                code: "travellers",
                explanation: Yii.t('wui-shared-js', "Tableau des voyageurs avec des informations supplémentaires"),
                children: [
                    { code: "{{title}}", explanation: Yii.t('wui-shared-js', "M., Mme., Mlle") },
                    { code: "{{firstname}}", explanation: Yii.t('wui-shared-js', "Prénom") },
                    { code: "{{lastname}}", explanation: Yii.t('wui-shared-js', "Nom") },
                    { code: "{{givenname}}", explanation: Yii.t('wui-shared-js', "Surnom") },
                    { code: "{{name}}", explanation: Yii.t('wui-shared-js', "Prénom + (givenname) + nom de famille du voyageur") },
                    { code: "{{type}}", explanation: Yii.t('wui-shared-js', "Adulte, enfant, bébé") },
                    { code: "{{ticket}}", explanation: Yii.t('wui-shared-js', "Numéro de billet") },
                    { code: `{{#luggages}}${this.labels.luggagesDetails}{{/luggages}}`, explanation: Yii.t('wui-shared-js', "Liste des bagages")},
                    {
                        code: "luggages",
                        explanation: Yii.t('wui-shared-js', "Bagages"),
                        children: [
                            { code: "{{#hold}}{{.}}{{/hold}}", explanation: Yii.t('wui-shared-js', "Tableau d'informations bagage en soute (par exemple '1 pièce de 23kg')") },
                            { code: "{{#cabin}}{{.}}{{/cabin}}", explanation: Yii.t('wui-shared-js', "Tableau d'informations bagage en soute (par exemple '1 pièce')") },
                        ]
                    },
                    { code: "{{#ssr}}{{.}}{{/ssr}}", explanation: Yii.t('wui-shared-js', "Tableau d'informations sur des services spéciaux (par exemple 'Repas enfant - PBLEUE - confirmé')") },
                ]
            },
        ]
    };

    public getHelpModel (): IVariableEntry {
        return {
            explanation: Yii.t('wui-shared-js', "Aide sur les variables"),
            children: [
                this.code,
                this.agent,
                { code: `{{#customers}}${this.labels.customersDetails}{{/customers}}`, explanation: Yii.t('wui-shared-js', "Liste des clients") },
                this.customer,
                { code: `{{#travellers}}${this.labels.travellersDetails}{{/travellers}}`, explanation: Yii.t('wui-shared-js', "Liste des voyageurs")},
                this.travellers,
                this.alltravellers,
                this.price,
                this.carrier,
                this.carriercode,
                { code: `{{#sectors}}${this.labels.sectorsDetails}{{/sectors}}`, explanation: Yii.t('wui-shared-js', "Liste des secteurs")},
                this.sectors
            ],
        };
    }
}
